import React from "react";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import InfoIcon from "@mui/icons-material/Info";
import Link from "@mui/material/Link";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";

const CustomDialogTitle = (props) => {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle style={{ margin: 0 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          style={{ color: "darkgray", right: 0, top: 0, position: "absolute" }}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

// When included a small info icon (botton) will be inserted, and when clicked a modal will open.
// Provide a title, text and optionally a link to more info
// The title should be lowercase, since it will be used as aria label and in the link text
// generated link text example: Læs mere om usikkerheder
const InfoDialog = ({ title, text, link }) => {
  // return (
  //   <div style={{ padding: "20px", background: "lightgreen" }}>
  //     I am a lazy-loaded component!
  //   </div>
  // );
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const openInfoDialog = () => {
    setOpen(true);
  };

  return (
    <>
      <IconButton
        edge="start"
        size="small"
        style={{ marginLeft: "0px" }}
        onClick={openInfoDialog}
        aria-label={`Klik for mere info om ${title}`}
      >
        <InfoIcon style={{ fontSize: 22, color: "#898989" }} />
      </IconButton>
      <Dialog open={open} onClose={handleClose} aria-labelledby="info-dialog">
        <CustomDialogTitle id="info-dialog" onClose={handleClose}>
          {`${title[0].toUpperCase()}${title.slice(1)}`}
        </CustomDialogTitle>
        <DialogContent>
          <Typography gutterBottom>{text}</Typography>
          {link && (
            <Typography gutterBottom>
              <Link href={link} underline="hover">
                Læs mere om {title}
              </Link>
            </Typography>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default InfoDialog;
